/* 司机创建的排班-时刻表 */
<template>
  <div id="schedulingDriverTimeForm">
    <div class="head">
      <img src="@/assets/img/line.png" />
      <div>{{ lineInfo.startStationName }} - {{ lineInfo.endStationName }}</div>
    </div>

    <div class="tips">功能说明：添加专线包车并保存，乘客在小程序上选择本线路后，就能在班次列表中看到专线包车服务</div>

    <div class="block-content">
      <el-table :data="tableData" height="400" border empty-text="暂无数据">
        <el-table-column label="车型名称" prop="intercityName"></el-table-column>
        <el-table-column label="车型" prop="vehicleSeat" width="80" v-slot="{ row }">
          {{ row.vehicleSeat }} 座
        </el-table-column>
        <el-table-column label="车型描述" prop="remark"></el-table-column>
        <el-table-column label="服务费用" prop="serviceFee" width="80" v-slot="{ row }">
          <span style="color:#FF6600">￥{{ row.serviceFee }}</span>
        </el-table-column>
        <el-table-column label="服务时间" prop="bestTime" v-slot="{ row }">
          {{ row.startTime }} - {{ row.endTime }}
        </el-table-column>
        <el-table-column label="启用" v-slot="{ row }">
          <el-switch v-model="row.status" :active-value="1" :inactive-value="2" @change="switchChange($event, row)">
          </el-switch>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template v-slot="{ row }">
            <el-button @click="editComboClick(row)" type="text" size="small">编辑</el-button>
            <el-button type="text" size="small" @click="deleteCombo(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button style="width: 100%;margin-top:10px;padding: 10px;border: 1px #dcdfe6 dashed;" @click="addCombo">
        <i class="el-icon-circle-plus-outline"></i> 添加车型
      </el-button>
    </div>

    <div class="block">
      <div class="block__left">专线包车上架规则</div>
      <div class="block__right">
        <el-button v-if="!ruleShelfTypeEdit" type="primary" size="mini" @click="ruleShelfTypeEdit = true">编辑</el-button>
        <div v-else>
          <el-button type="primary" size="mini" @click="saveRuleShelfType">保存</el-button>
          <el-button size="mini" @click="setRuleShelfType">取消</el-button>
        </div>
      </div>
    </div>

    <div class="block-content">
      <el-radio-group v-model="ruleShelfType" :disabled="!ruleShelfTypeEdit">
        <el-radio :label="1">
          <div>跟随专线班次的日期来上架</div>
          <div>说明：假设有1号、2号的专线班次，则只能在这2天中选择专线包车服务</div>
        </el-radio>
        <el-radio :label="2">
          <div>
            始终保持未来
            <el-input v-model="intercityTime" :disabled="ruleShelfType == 1 || !ruleShelfTypeEdit" maxlength="2"
              @input="intercityTime = intercityTime.replace(/[^\d]/g, '').replace(/^0/g, '').replace(/^[3][1-9]{1,}/g, '30').replace(/^[4-9][0-9]{1,}/g, '30')"
              style="width:50px;" />
            天上架
          </div>
          <div>说明：假设配置为10天上架，则表示每天都能选择未来10天的专线包车服务</div>
        </el-radio>
      </el-radio-group>
    </div>

    <div class="block">
      <div class="block__left">专线包车提成规则</div>
      <div class="block__right" style="color:#0066FF;cursor: pointer;" @click="visibleCommissionConfig = true;">
        {{ intercityCommissionConfigName || '未设置' }}
      </div>
    </div>

    <el-dialog :visible.sync="visibleCombo" @close="closeVisibleCombo" width="50%" :title="titleCombo"
      :close-on-click-modal="false">
      <el-form :model="formCombo" :rules="rulesCombo" ref="formCombo" label-position="left" label-width="80px">
        <el-row>
          <el-col :span="11">
            <el-form-item label="车型名称" prop="intercityName">
              <el-input v-model="formCombo.intercityName" maxlength="8" placeholder="展示给用户看的车型名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :offset="2">
            <el-form-item label="选择车型" prop="vehicleSeat">
              <el-select v-model="formCombo.vehicleSeat" filterable>
                <el-option v-for="item in $const.SEATNUMBER" :label="item.label" :key="item.value"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="车型描述" prop="remark">
              <el-input v-model="formCombo.remark" maxlength="20" placeholder="展示给用户看的描述"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :offset="2">
            <el-form-item label="服务时间" prop="startTime" class="startTime">
              <el-time-select placeholder="起始" v-model="formCombo.startTime" value-format="HH"
                :picker-options="{ start: '00:00', step: '01:00', end: '24:00', maxTime: formCombo.endTime }" />
              <span style="margin:0 10px">至</span>
              <el-time-select placeholder="结束" v-model="formCombo.endTime" value-format="HH"
                :picker-options="{ start: '00:00', step: '01:00', end: '24:00', minTime: formCombo.startTime }" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-form-item label="服务费用" prop="serviceFee">
              <el-input v-model="formCombo.serviceFee" maxlength="64" placeholder="专线包车服务费用"
                @input="() => formCombo.serviceFee = formCombo.serviceFee.replace(/^0/g, '').replace(/^[1-9][0-9]{4,}/g, '9999').replace(/(\d\d{0,3}\.?\d{0,2})?.*/g, '$1')">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item label="费用说明" prop="serviceFeeExplainStatus">
            <el-switch v-model="formCombo.serviceFeeExplainStatus" :active-value="1" :inactive-value="2"
              @change="serviceFeeExplainStatusChange" style="margin:5px 0 10px;" />
            <wangEditor ref="editor" :getTrigger="getTrigger" :content.sync="formCombo.serviceFeeExplain" />
          </el-form-item>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer"
        style="padding-left:80px;text-align: center;padding-top: 0;position: relative;top: -15px;">
        <el-button type="primary" :loading="loadingCombo" @click="saveCombo" style="width:100%">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="visibleCommissionConfig" title="更换提成规则" width="30%">
      <el-table border stripe max-height="600" size="mini" class="zoeTable" empty-text="暂无数据" highlight-current-row
        :data="commissionConfigTable">
        <el-table-column :show-overflow-tooltip="true" prop="name" label="规则名称">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="type" label="提成规则" v-slot="scope">
          {{ scope.row.type == 1 ? "比例提成" : "阶梯提成" }}
        </el-table-column>
        <el-table-column label="操作" width="80" v-slot="scope">
          <el-radio :label="scope.$index" v-model="radioCommissionConfig" :disabled="disableCommissionConfig"
            @change.native="checkCommissionConfig = scope.row"><span></span></el-radio>
        </el-table-column>
      </el-table>
      <el-switch style="margin: 10px 0" v-model="disableCommissionConfig" active-text="无提成规则"
        @change="changeCommissionConfig">
      </el-switch>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveCommissionConfig">保存
        </el-button>
        <el-button @click="closeCommissionConfig">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "schedulingDriverTimeForm",
  components: {
    schedulingVehicle: () => import("./schedulingVehicle.vue"),
    wangEditor: () => import("@/components/wangEditor"),
  },
  props: ['lineId'],
  data() {
    return {
      lineInfo: {}, // 线路详情信息
      tableData: [], // 包车套餐列表

      visibleCombo: false,
      titleCombo: '',
      formCombo: { // 包车套餐对象
        intercityName: null,
        vehicleSeat: null,
        remark: null,
        serviceFeeExplainStatus: 2,
        serviceFee: null,
        startTime: '07:00',
        endTime: '18:00'
      },
      rulesCombo: { // 套餐对象校验规则
        intercityName: [{ required: true, message: "请输入车型名称" }],
        vehicleSeat: [{ required: true, message: "请选择车型" }],
        remark: [{ required: true, message: "请输入车型描述" }],
        serviceFee: [{ required: true, message: "请输入服务费用" }],
        startTime: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error("请输入起始时间"));
            } else if (!this.formCombo.endTime) {
              callback(new Error("请输入结束时间"));
            } else {
              callback();
            }
          }
        }],
        serviceFeeExplainStatus: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value == 1 && !this.formCombo.serviceFeeExplain) {
              callback(new Error("请输入费用说明"));
            } else {
              callback();
            }
          }
        }]
      },
      loadingCombo: false,

      ruleShelfTypeEdit: false,
      ruleShelfType: true,
      intercityTime: null,

      intercityCommissionConfigId: null,
      intercityCommissionConfigName: null,
      commissionConfigTable: [],
      visibleCommissionConfig: false,
      disableCommissionConfig: false,
      radioCommissionConfig: null,
      checkCommissionConfig: null,

      getTrigger: 0
    };
  },
  watch: {
  },
  async mounted() {
    this.getTable();
    await this.getInfo();
    this.getCommissionConfigTable();
  },
  methods: {
    /* 获取线路信息 */
    async getInfo() {
      let url = "/api/v1/manage/line/scheduling/" + this.lineId;
      let res = await this.$axios.get(url, { channel: 1 });
      if (res?.code == 1) {
        this.lineInfo = res.data.line || {};
        this.intercityCommissionConfigId = this.lineInfo.intercityCommissionConfigId;
        this.intercityCommissionConfigName = this.lineInfo.intercityCommissionConfigName;
        this.setRuleShelfType();
      }
    },

    /* 获取包车配置列表 */
    async getTable() {
      let url = "/api/v1/manage/line/intercity";
      let res = await this.$axios.get(url, { lineId: this.lineId });
      if (res?.code == 1) {
        this.tableData = res.data || [];
      }
    },

    /* 专线包车车型添加 */
    addCombo() {
      this.visibleCombo = true;
      this.titleCombo = '添加车型';
      this.$nextTick(() => {
        setTimeout(() => {
          this.serviceFeeExplainStatusChange(2)
        }, 10);
      })
    },


    /* 专线包车车型编辑 */
    editComboClick(row) {
      this.visibleCombo = true;
      this.titleCombo = "编辑车型";
      this.$nextTick(() => {
        this.formCombo = { ...row };
        setTimeout(() => {
          this.$refs.editor.setHtml(row.serviceFeeExplain);
          this.serviceFeeExplainStatusChange(row.serviceFeeExplainStatus)
        }, 10);
      })
    },

    /* 专线包车车型保存 */
    async saveCombo() {
      this.$refs.formCombo.validate(async (valid) => {
        if (valid) {
          let url = '/api/v1/manage/line/intercity'
          let data = await this.$axios[this.formCombo.id ? 'put' : 'post'](url, { ...this.formCombo, lineId: this.lineId });
          if (data && data.code === 1) {
            this.$message.success('已保存');
            this.visibleCombo = false;
            this.getTable();
          }
        }
      })
    },

    /* 关闭套餐编辑 */
    closeVisibleCombo() {
      this.formCombo = { // 包车套餐对象
        id: null,
        intercityName: null,
        vehicleSeat: null,
        remark: null,
        serviceFee: null,
        serviceFeeExplainStatus: 2,
        startTime: '07:00',
        endTime: '18:00'
      }
      this.$refs.editor.clear();
      this.$nextTick(() => {
        this.$refs.formCombo.clearValidate();
      })
    },

    /* 套餐删除 */
    async deleteCombo(lineIntercityId) {
      let url = '/api/v1/manage/line/intercity'
      let data = await this.$axios.delete(url, { lineIntercityId });
      if (data && data.code === 1) {
        this.$message.success('已删除');
        this.getTable();
      }
    },

    /* 车型启用开关点击 */
    switchChange(status, row) {
      let params = {
        lineIntercityId: row.id,
        status: row.status
      };
      if (status == 1) {
        this.$confirm("确认启用吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "success",
        }).then(() => {
          this.switchPost(params, status, row);
        }).catch(() => {
          row.status = 2;
        });
      } else {
        this.$confirm("确认关闭吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.switchPost(params, status, row);
        }).catch(() => {
          row.status = 1;
        });
      }
    },

    /* 车型启用开关更改 */
    switchPost(params, status, row) {
      let url = "/api/v1/manage/line/intercity/status";
      this.$axios.post(url, params).then((data) => {
        if (data && data.code == 1) {
          if (status == 1) {
            this.$message.success("已启用");
          } else {
            this.$message.success("已关闭");
          }
          this.getInfo();
        } else {
          row.status = row.status == 1 ? 2 : 1;
        }
      }).catch((err) => {
        row.status = row.status == 1 ? 2 : 1;
      });
    },

    /* 获取上架规则 */
    setRuleShelfType() {
      this.ruleShelfTypeEdit = false;
      this.ruleShelfType = this.lineInfo.intercityTime ? 2 : 1;
      this.intercityTime = this.lineInfo.intercityTime || null;
    },

    /* 保存上架规则 */
    async saveRuleShelfType() {
      if (this.ruleShelfType == 2 && !this.intercityTime) {
        this.$message.info("请输入天数");
        return;
      }
      let url = "/api/v1/manage/line/intercity/time";
      let res = await this.$axios.post(url, { lineId: this.lineId, intercityTime: this.ruleShelfType == 1 ? 0 : this.intercityTime });
      if (res?.code == 1) {
        this.getInfo();
        this.$message.success("已保存");
        this.ruleShelfTypeEdit = false;
      }
    },

    /* 获取提成规则 */
    async getCommissionConfigTable() {
      let params = { organizationId: this.lineInfo.organizationId };
      let url = "/api/v1/manage/line/intercity/commissionConfig";
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        this.commissionConfigTable = data.data;
        if (this.intercityCommissionConfigId) {
          this.commissionConfigTable.map((item, index) => {
            if (item.id == this.intercityCommissionConfigId) {
              this.radioCommissionConfig = index;
              this.checkCommissionConfig = item;
            }
          });
        } else {
          this.disableCommissionConfig = true;
        }
      }
    },

    /* 无规则状态切换 */
    changeCommissionConfig(val) {
      this.disableCommissionConfig = val;
      if (val) {
        this.radioCommissionConfig = null;
        this.checkCommissionConfig = null;
      }
    },

    /* 保存更换规则 */
    async saveCommissionConfig() {
      if (this.checkCommissionConfig || this.disableCommissionConfig) {
        let params = {
          lineId: this.lineId,
          intercityCommissionConfigId: this.checkCommissionConfig ? this.checkCommissionConfig.id : null,
        };
        let url = "/api/v1/manage/line/intercity/commission";
        let data = await this.$axios.post(url, params);
        if (data && data.code === 1) {
          this.$message.success("已更换规则");
          this.visibleCommissionConfig = false;
          this.getInfo();
        }
      } else {
        this.$message.warning("请选择一条规则，或打开无提成规则");
      }
    },

    /* 取消更换规则 */
    closeCommissionConfig() {
      this.visibleCommissionConfig = false;
      if (this.intercityCommissionConfigId) {
        this.disableCommissionConfig = false;
        this.commissionConfigTable.map((item, index) => {
          if (item.id == this.intercityCommissionConfigId) {
            this.radioCommissionConfig = index;
            this.checkCommissionConfig = item;
          }
        });
      } else {
        this.disableCommissionConfig = true;
      }
    },

    /* 费用说明切换 */
    serviceFeeExplainStatusChange(event) {
      if (event == 2) {
        this.$refs.editor.editor.disable()
      } else {
        this.$refs.editor.editor.enable()
      }
    },

  },
};
</script>

<style lang="less" scoped>
#schedulingDriverTimeForm {
  padding-bottom: 50px;

  .head {
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    img {
      width: 20px;
      margin-right: 8px;
    }

    div {
      font-size: 20px;
      font-weight: bold;
    }
  }

  .tips {
    color: #999;
  }

  .block {
    width: 750px;
    margin-top: 30px;
    display: flex;
    align-items: center;

    &__left {
      font-weight: bold;
      width: 120px;
    }

    &__right {
      flex-grow: 1;
    }

  }

  .block-content {
    margin-top: 10px;

    .el-radio-group .el-radio {
      display: flex;
      align-items: center;

      /deep/ .el-radio__label {
        padding: 3px 10px 7px;
        display: flex;
        align-items: center;

        &>div {
          &:nth-child(1) {
            width: 200px;
            color: #333;
          }

          &:nth-child(2) {
            width: 200px;
            color: #999;
          }
        }
      }
    }
  }
}

.startTime /deep/.el-form-item__content {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .el-date-editor {
    flex-grow: 1;
  }
}
</style>
